<!-- Vendor Management -->
<div class="d-flex flex-column flex-column-fluid">
  <!-- Vendors Listing Component -->
  <app-md-vendors-listing #vendorsListing>
  </app-md-vendors-listing>
</div>

<!-- Vendor Add/Edit Modal -->
<app-vendor-add-edit
  (vendorAdded)="onVendorAdded()"
  (vendorUpdated)="onVendorUpdated()">
</app-vendor-add-edit>
